import L from 'L'

var theSidebar = null

module.exports = () => {
  if (!theSidebar) {
    var sidebar = L.control.sidebar('sidebar', {
      position: 'left'
    })

    theSidebar = sidebar
  }
  return theSidebar
}



// WEBPACK FOOTER //
// ./src/assets/js/sidebar.js